import { render, staticRenderFns } from "./ApprovalWorkflows.vue?vue&type=template&id=cf37f27e"
import script from "./ApprovalWorkflows.vue?vue&type=script&lang=js"
export * from "./ApprovalWorkflows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports